import { mddApiSliceGenerated } from './mddApiSliceGenerated'

export const mddApi = mddApiSliceGenerated.enhanceEndpoints({
	addTagTypes: ['Templates', 'Domains', 'SqlPreview'],
	endpoints: {
		createTemplateV1UsingPost: {
			invalidatesTags: ['Templates'],
		},
		getAllTemplatesV1UsingGet: {
			providesTags: ['Templates'],
		},
		updateTemplateV1UsingPut: {
			invalidatesTags: ['Templates'],
		},
		deleteTemplateV1UsingDelete: {
			invalidatesTags: ['Templates'],
		},
		getTemplateV1UsingGet: {
			providesTags: ['Templates'],
		},
		getAllDomainsFilteredBySystemTechnologyDepUsingGet: {
			providesTags: ['Domains'],
		},
		/** Used by Preview tab; invalidated after structure save (e.g. ViewDetailV2) */
		generateSqlPreviewUsingGet: {
			providesTags: (_result, _error, arg) => [
				{ type: 'SqlPreview', id: arg.structureId },
			],
		},
	},
})

export const {
	useAddApiUserUsingPostMutation,
	useAdjustTableNameUsingPostMutation,
	useApiUserResetSecretUsingPostMutation,
	useApiUserUpdateUsingPostMutation,
	useChangeReleaseStatusUsingPatchMutation,
	useCheckStructureUsingGetQuery,
	useCreateTemplateV1UsingPostMutation,
	useCreateUsingPostMutation,
	useDeleteApiUserUsingDeleteMutation,
	useDeleteTemplateV1UsingDeleteMutation,
	useGetAllCustomAttributesForComboUsingGetQuery,
	useGetAllCustomAttributesUsingGetQuery,
	useGetAllDomainsFilteredBySystemTechnologyDepUsingGetQuery,
	useGetAllNodeHistoryUsingGetQuery,
	useGetAllTechnologiesUsingGetQuery,
	useGetAllTemplatesV1UsingGetQuery,
	useGetApiUsersUsingGetQuery,
	useGetAvailableStructureForSourceObjectUsingGetQuery,
	useGetEnvironmentsWithLastDeploymentPerObjectTypeUsingGetQuery,
	useGetExistingStructuresForSourceMappingUsingGetQuery,
	useGetMappingsUsingGetQuery,
	useGetNodeDetailUsingGetQuery,
	useGetNodeRelationsUsingGetQuery,
	useGetObjectSettingsByTypeUsingGetQuery,
	useGetReleaseEnvironmentsUsingGetQuery,
	useGetStereotypeTypesUsingGetQuery,
	useGetStereotypesForTemplatesUsingGetQuery,
	useGetStereotypesUsingGetQuery,
	useGetSystemReleaseUsingGetQuery,
	useGetSystemReleasesUsingGetQuery,
	useGetSystemUsersUsingGetQuery,
	useGetTemplateV1UsingGetQuery,
	useGenerateSqlPreviewUsingGetQuery,
	useGetUsersForComboUsingGetQuery,
	useLazyGenerateAndPushToGitUsingGetQuery,
	useLazyGetAvailableStructureForSourceObjectUsingGetQuery,
	useLazyGetNodeDetailUsingGetQuery,
	useLazyGetTaskExecutionUsingGetQuery,
	useLazySearchStructureUsingGetQuery,
	useSearchFullTextJsonUsingGetQuery,
	useUpdateSystemReleaseUsingPutMutation,
	useUpdateTemplateV1UsingPutMutation,
	useCancelTaskUsingDeleteMutation,
	useLazyGetTaskResultFileUsingGetQuery,
} = mddApi
